// extracted by mini-css-extract-plugin
var _1 = "_ConfirmCancelTransactionPendingModal-module__button-container";
var _2 = "_ConfirmCancelTransactionPendingModal-module__cancel-button";
var _3 = "_ConfirmCancelTransactionPendingModal-module__confirm-cancel";
var _4 = "_ConfirmCancelTransactionPendingModal-module__title-text";
export { _1 as "button-container", _2 as "cancel-button", _3 as "confirm-cancel", _4 as "title-text" }
